import { render } from "./PdfEdit.vue?vue&type=template&id=33a1e5d6"
import script from "./PdfEdit.vue?vue&type=script&lang=js"
export * from "./PdfEdit.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__